module.exports = __webpack_public_path__ + "img/aansluiting_vo.ae6cd99a.svg";